
// Tracking implementation file for all types of event associated with Napkin
const { trackingEventDataDispatcher, trackingEventDataListener } = require('./trackingUtils');
const trackingSchema = require('../constants/schema/v1.json');

const {
    getTrackingCacheHitURLEvent,
    getTrackingHTTPCodeEvent,
    getTrackingErrorMessagesEvent,
    getTrackingPlacementIdsEvent
} = require('../eventNames');
/**
 * Mapping between different fieldNames and the associated event names to attach the event Names specific listeners
 */
const eventNameMapping = new Map([
    ['url', (placementId) => getTrackingCacheHitURLEvent(placementId)],
    ['httpCode', (placementId) => getTrackingHTTPCodeEvent(placementId)],
    ['error', (placementId) => getTrackingErrorMessagesEvent(placementId)],
    ['placementIds', (placementId) => getTrackingPlacementIdsEvent(placementId)]
]);

/**
 * CacheHit event deals with paticularities of response received as soon as we hit napkin.
 * With v1, It involves tracking:
 *  - url being requested
 *  - httpCode received in response
 *  - error messages if received in response
 *  - placementIds that were received in response
 * @param {number} placementId
 * @param {AdsResponseModule.meta.trackingList (eventAction === "CACHE_HIT")} cacheHitEvent
 */

const cacheHit = (placementId) => {
    if (trackingSchema && trackingSchema.schema && trackingSchema.schema.fields && Array.isArray(trackingSchema.schema.fields)) {
        // For each field in the trackingList (with eventAction == CACHE_HIT), attach event Listener
        trackingSchema.schema.fields.forEach((field) => {
            if (eventNameMapping.has(field.name)) {
                trackingEventDataListener(eventNameMapping.get(field.name)(placementId));
            }
        });
    }
};

const ebayAdsTrackingDispatcher = (fieldName, placementId, data) => {
    if (eventNameMapping.has(fieldName)) {
        trackingEventDataDispatcher(fieldName, eventNameMapping.get(fieldName)(placementId), placementId, data);
    }
};

const ebayAdsFlushTrackingData = (placementId) => {
    if (window.ebay.ads.tracking[placementId]) {
        /**
         * fetch call with data: window.ebay.ads.tracking[placementId]
         * fingerprint: require('constants/schema/v1.json').fingerprint
         */
    }
};

module.exports = {
    cacheHit,
    ebayAdsTrackingDispatcher,
    ebayAdsFlushTrackingData
};
